import useUsuario from "~fetchs/useUsuario";
import useCheckIn from "~fetchs/Roterizacao/useCheckIn";
import { CheckIcon } from "@chakra-ui/icons";
import { FormControl } from "@chakra-ui/react";
import React, { useRef, useMemo, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Link, useNavigate, useParams } from "react-router-dom";
import useGrupoProduto from "~/fetchs/useGrupoProduto";
import useProduto from "~/fetchs/useProduto";
import useSelect from "~components/Form/hooks/useSelect";
import useLocalStorage from "~hooks/useLocalStorage";
import { CleanFiltersIcon, IconSearch, PranchetaRoteirizacao} from "~misc/icons";
import { initialPath } from "~misc/paths";
import useHeader from "~components/Header/hooks/useHeader";
import usePesquisasCampoClientes from "~/fetchs/usePesquisasCampoClientes";
import { useSearchParams } from "react-router-dom";

const RotaDoDiaGraficoClientePesquisar = ({ cleanFilters, setStartDate, trilhaName }) => {
  const { usuario } = useUsuario();
  const formikRef = useRef();
  const { grupoProduto, grupoProdutoSelect } = useGrupoProduto({
    formikRef,
  });
  const { produtoSelect } = useProduto({
    grupoProduto,
    formikRef,
  });
  const { parameter } = useParams();
  const { path } = useHeader();
  const periodoSelect = useSelect("periodo");
  const [validation, setLocalStorage] = useLocalStorage("validation", null);

  const regexConsulta = /^\/roteirizacao\/consulta\/\d+$/;
  const isVisualizationMode = regexConsulta.test(path);

  const storagePesquisas = JSON.parse(localStorage.getItem("cliente-pesquisas-mm") || "{}");
  const hoje = new Date().toISOString().split("T")[0];
  const chavePesquisa = Object.keys(storagePesquisas).find((key) => key.startsWith(`${+parameter} - ${hoje}`));
  const dadosDaPesquisa = chavePesquisa ? storagePesquisas[chavePesquisa]?.dados : null;
  const dadosValidos = dadosDaPesquisa != null;
  const [searchParams] = useSearchParams();
  const mapeamento = searchParams.get("mapeamento");
  const { checkin } = useCheckIn();
  const acompanhamentoVisitado = Boolean(
    checkin?.funilAcompanhamentoVisitado &&
    Number(checkin.clienteId) === Number(parameter)
  );

  const navigate = useNavigate();

  const [filters, setFilters] = useState({ searchText: "", status: "Todos", title: 0, validityPeriod: "Todos" });
  const { pesquisasCampoCliente } = usePesquisasCampoClientes({ 
    filters, 
    clienteId: parseInt(parameter), 
    tipo: "ativos" 
  });

  const temPesquisasVigentes = useMemo(() => {
    if (!pesquisasCampoCliente) return false;
    return pesquisasCampoCliente.length > 0;
  }, [pesquisasCampoCliente]);

  return (
    <div className="flex flex-col  md:flex-row justify-between mt-6 mb-8 items-center max-w-[1280px] m-auto gap-4 ">
      <button
        type="button"
        className="flex items-center gap-4 mr-6 cursor-pointer"
        onClick={() => {
          cleanFilters();
          grupoProdutoSelect.upDateDefaultValue("");
          grupoProdutoSelect.upDateValue("");
          produtoSelect.upDateValue("");
          produtoSelect.upDateDefaultValue("");
          periodoSelect.upDateValue("");
          periodoSelect.upDateDefaultValue("");
          setStartDate("");
        }}
      >
        <span className="font-semibold text-lg cursor-pointer">Limpar Filtros</span>
        <CleanFiltersIcon />
      </button>
      
        <div className="flex justify-center md:justify-end max-w-[800px] space-x-2">
          {
            temPesquisasVigentes && (
              <Link
                onClick={(e) => {
                  const queryParams = isVisualizationMode
                    ? "?origem=roteirizacao&cameFromVisitaView=true"
                    : "?origem=roteirizacao";
                  navigate(`${initialPath}/gestao-de-pesquisa/formularios/${parameter}${queryParams}`);
                }}
                className={ `col-span-1 button-search flex py-5 mt-[8px] h-[49.99px] px-10 bg-primaria rounded-lg gap-4 font-bold text-white text-lg justify-center items-center`}
              >
                Formulários
                <PranchetaRoteirizacao bgColor="#fff" strokeColor="#01054C" height="20" width="16"/>
              </Link>
            )
          }
          {trilhaName !== "IMO" && trilhaName !== "INFRA" && trilhaName !== undefined && (
            <FormControl>
              <Link
                onClick={() => { 
                  setLocalStorage(null);
                  const queryParams = isVisualizationMode
                    ? "?origem=roteirizacao&cameFromVisitaView=true"
                    : "?origem=roteirizacao";
                  navigate(`${initialPath}/pesquisa-de-preco/${parameter}${queryParams}`);
                }}
                className={
                  +parameter === validation && dadosValidos
                    ? "col-span-1 button-search flex py-5 mt-[8px] h-[49.99px] px-10 bg-[#7DA62D] rounded-lg gap-4 font-bold text-white text-lg justify-center items-center"
                    : "col-span-1 button-search flex py-5 mt-[8px] h-[49.99px] px-10 bg-primaria rounded-lg gap-4 font-bold text-white text-lg justify-center items-center"
                }
              >
                {+parameter === validation && <CheckIcon className="icon !w-[10px] !h-[10px]" />}
                Pesquisar preço
                <IconSearch fill="#FFF" width={15} height={15} />
              </Link>
          </FormControl>
          )}
          {(trilhaName === "IMO" || trilhaName === "INFRA") && usuario?.slugAcessos?.includes('acesso-ao-menu-de-funil-de-obras') && (
            <FormControl>
              <Link
                onClick={() => { 
                  navigate(`${initialPath}/funil-de-obras/${parameter}/mapeamento?origem=roteirizacao&retorno=roteirizacao`);
                }}
                className={
                  mapeamento === "sucesso" || acompanhamentoVisitado
                    ? "col-span-1 button-search flex py-5 mt-[8px] h-[49.99px] px-10 bg-[#7DA62D] rounded-lg gap-4 font-bold text-white text-lg justify-center items-center uppercase"
                    : "col-span-1 button-search flex py-5 mt-[8px] h-[49.99px] px-10 bg-primaria rounded-lg gap-4 font-bold text-white text-lg justify-center items-center uppercase"
                }
              >
                Funil de Obras
              </Link>
          </FormControl>
          )}
        </div>
    </div>
  );
};

RotaDoDiaGraficoClientePesquisar.propTypes = {
  cleanFilters: PropTypes.func,
  setStartDate: PropTypes.func,
  trilhaName: PropTypes.string,
};

export default RotaDoDiaGraficoClientePesquisar;
